function initMadesaComparativo(root) {
  var sections = [];

  if (root && root.classList && root.classList.contains('madesa-comparativo')) {
    sections = [root];
  } else if (root && root.querySelectorAll) {
    sections = Array.prototype.slice.call(root.querySelectorAll('.madesa-comparativo'));
  } else {
    sections = Array.prototype.slice.call(document.querySelectorAll('.madesa-comparativo'));
  }

  sections.forEach(function (section) {
    if (!section || section.getAttribute('data-initialized') === 'true') return;
    section.setAttribute('data-initialized', 'true');

    var tabButtons = section.querySelectorAll('[data-tab-btn]');
    var panels = section.querySelectorAll('[data-tab-panel]');

    tabButtons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var target = btn.getAttribute('data-tab-btn');

        tabButtons.forEach(function (b) {
          var isActive = b === btn;
          b.classList.toggle('is-active', isActive);
          b.setAttribute('aria-selected', isActive ? 'true' : 'false');
        });

        panels.forEach(function (panel) {
          panel.classList.toggle('is-active', panel.getAttribute('data-tab-panel') === target);
        });
      });
    });

    var track = section.querySelector('[data-cost-track]');
    var fill = section.querySelector('[data-cost-progress-fill]');

    if (track) {
      var isDown = false;
      var didDrag = false;
      var startX = 0;
      var scrollStart = 0;

      track.addEventListener('pointerdown', function (e) {
        if (e.pointerType !== 'mouse') return;
        isDown = true;
        didDrag = false;
        startX = e.clientX;
        scrollStart = track.scrollLeft;
        track.classList.add('is-dragging');
        track.setPointerCapture(e.pointerId);
      });

      track.addEventListener('pointermove', function (e) {
        if (!isDown || e.pointerType !== 'mouse') return;
        var delta = e.clientX - startX;
        if (Math.abs(delta) > 3) didDrag = true;
        track.scrollLeft = scrollStart - delta;
      });

      var endDrag = function () {
        if (!isDown) return;
        isDown = false;
        track.classList.remove('is-dragging');
      };

      track.addEventListener('pointerup', endDrag);
      track.addEventListener('pointerleave', endDrag);
      track.addEventListener('pointercancel', endDrag);

      track.addEventListener('click', function (e) {
        if (didDrag) {
          e.preventDefault();
          e.stopPropagation();
        }
      }, true);
    }

    if (track && fill) {
      var updateProgress = function () {
        var maxScroll = track.scrollWidth - track.clientWidth;
        if (maxScroll <= 0) {
          fill.style.width = '100%';
          return;
        }
        var ratio = track.scrollLeft / maxScroll;
        var cardCount = track.children.length || 1;
        var minWidth = 100 / cardCount;
        var fillWidth = minWidth + (ratio * (100 - minWidth));
        fill.style.width = fillWidth + '%';
      };

      track.addEventListener('scroll', updateProgress, { passive: true });
      window.addEventListener('resize', updateProgress);
      updateProgress();
    }
  });
}

document.addEventListener('DOMContentLoaded', function () {
  initMadesaComparativo();
});

document.addEventListener('shopify:section:load', function (event) {
  initMadesaComparativo(event.target);
});
